import { http } from './http'

export function getOrderByDate (date) {
  return http.get(`/api/orders/${date}`)
}

export function setMealQty (date, meal, qty) {
  return http.put(`/api/orders/${date}/meals/${meal}`, { qty })
}

export function setOrderComment (date, comment) {
  return http.put(`/api/orders/${date}/comment`, { comment })
}

export function addChildToMeal (date, childId, meal, note = null) {
  return http.post(`/api/orders/${date}/children/${childId}/${meal}`, { note })
}

export function removeChildFromMeal (date, childId, meal) {
  return http.delete(`/api/orders/${date}/children/${childId}/${meal}`)
}

export function setOrderSpecialQty (date, meal, specialTypeId, qty) {
  return http.put(`/api/orders/${date}/specials/${meal}/${specialTypeId}`, { qty })
}

export function getWeekOrders (start) {
  return http.get(`/api/orders/week?start=${encodeURIComponent(start)}`)
}
